import React, { useState } from "react";
import Topbar from "../../Component/Topbar/Topbar";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";

import {
  blue,
  edit,
  green,
  orange,
  person,
  pink,
  red,
  search,
} from "../../assets/img";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { Table } from "../../Component/Table/Table";
const Roles = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [loader, setLoader] = useState(false);
  const [popup, setPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const handleStatus = ({ id }) => {
    const updatedData = [...owners];
    const currentStatus = updatedData[id].status || "on";

    updatedData[id].status = currentStatus === "on" ? "off" : "on";
    setOwners(updatedData);
    console.log("KK", id);
  };
  const [owners, setOwners] = useState([
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: "Super Admin",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
    },
    {
      "S.No": "01",
      adminID: "Thor91",
      name: "Thor",
      Owner: "Sathish (Rob90)",
      role: " Inventory",
      "Registered Date": "12/02/2025",
      email: "thor@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "on",
    },
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: " Technical ",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: " Regional Manager ",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "on",
    },
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: " Service Engineer",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: " Admin",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
    {
      "S.No": "01",
      adminID: "Rob90",
      name: "Robert",
      Owner: "Sathish (Rob90)",
      role: " Admin",
      "Registered Date": "12/02/2025",
      email: "robert@gmail.com",
      number: "2345678974",
      City: "Chennai",
      "Total Property Count": 12,
      status: "off",
    },
  ]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
        },
      },


      {
        Header: "Role",
        accessor: "role",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          // If the role is Super Admin → show a dash instead of button
          if (row.original.role === "Super Admin") {
            return <span className="text-muted"></span>;
          }

          return (
            <div className="d-flex ac-jc">
              <button
                onClick={() => handleStatus(row)}
                className={`${value === "off" ? "deactive-icon1" : "active-icon1"
                  } f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16`}
              >
                {value === "off" ? "De-active" : "Active"}
              </button>
            </div>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-jc gap-3">
                {row.original.role === "Super Admin" ? (
                  <span className="text-muted"></span>
                ) : (
                  <button
                    onClick={() => {
                      navigate("/roles-add", { state: { type: "edit" } });
                    }}
                    className="cust-btn "
                  >
                    <img src={edit} alt="" className="editor-btn" />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );
  return (
    <>
      <Topbar header={"Roles"} />
      <div className="container_fluit1">
        <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
          Total Employee : 22
        </h4>
        <div className="search-input col-md-4 d-flex ac-jb my-4">
          <input
            type="text"
            placeholder="Search "
            style={{ border: "none", width: "250px" }}
            className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
          />
          <img src={search} className="search" />
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={owners}
          show={false}
        />
      </div>
    </>
  );
};

export default Roles;
